var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosCss3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 71,
    viewBox: "0 0 84 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9561 69.7817L12.6549 62.8596L6.12515 0.536713H77.8749L71.3383 62.85L41.9561 69.7817Z",
    fill: "#264DE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7423 58.8821L71.328 5.63245H42.0001V64.4833L65.7423 58.8821Z",
    fill: "#2965F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0944 28.7472L21.8994 36.3908H42V28.7472H21.0944ZM19.4767 13.2763L20.2932 20.92H42V13.2763H19.4767ZM42 48.5986L41.9607 48.6074L31.9572 46.3089L31.3176 40.2128H22.3007L23.559 52.2145L41.9587 56.5608L42 56.5512V48.5986Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8483 28.7472L64.4697 13.2763H41.9692V20.92H54.626L53.8087 28.7472H41.9692V36.3908H53.0299L51.987 46.3041L41.9689 48.6051V56.5572L60.3832 52.2145L60.5182 50.923L62.6292 30.7997L62.8483 28.7472Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosCss3);
export default __webpack_public_path__ + "static/media/logos_css-3.391c1f75c8d12c9f12479b126deea4f6.svg";
export { ForwardRef as ReactComponent };